<template>
	<layout-main-component class="watch-profile">
		<spinner v-if="loading.profile"/>
		<div v-else-if="profile">
			<h2>
				<span>{{ $t('labels.profile.personal_information') }}</span>
				<button-icon-text-loading @click.native="editProfile()" icon="edit">{{ $t('buttons.actions.edit_profile') }}</button-icon-text-loading>
			</h2>
			<p><b>{{ $t('labels.general.name') }}</b>{{ profile.name }}</p>
			<p><b>{{ $t('labels.general.birthdate') }}</b>{{ profile.birthday }} ({{ age }} {{ $t('labels.general.years_old') }})</p>
			<p><b>{{ $t('labels.general.blood_type') }}</b>{{ profile.blood_type }}</p>
			<p><b>{{ $t('labels.general.height') }}</b>{{ height }}</p>
			<p><b>{{ $t('labels.general.weight') }}</b>{{ weight }}</p>
			<p><b>{{ $t('labels.general.gender') }}</b>{{ profile.gender }}</p>
			<h2>
				<span>{{ $t('labels.profile.contacts') }}</span>
				<button-icon-text-loading @click.native="addContact()" icon="plus-w" class="plus">{{ $t('buttons.actions.add_contact') }}</button-icon-text-loading>
			</h2>
			<div>
				<div v-for="contact in profile.contacts" :key="contact.id" class="item contact">
					<div class="data">

						<b>{{ $t('labels.general.'+contact.type.replace(/ /g, '_').replace(/'/g, '´').toLowerCase()) }}</b>
						<span>{{ contact.contact }}</span>
					</div>
					<div class="btn-group">
						<button-icon-loading @click.native="editContact(contact.id)" icon="edit" class="btn-edit"/>
						<button-icon-loading @click.native="deleteContact(contact.id)" :loading="loading.delete.contact.has(contact.id)" icon="trash" class="btn-delete"/>
					</div>
				</div>
			</div>
			<h2>
				<span>{{ $t('labels.profile.medical_information') }}</span>
				<button-icon-text-loading @click.native="addDisease()" icon="plus-w" class="plus">{{ $t('buttons.actions.add_disease') }}</button-icon-text-loading>
			</h2>
			<div>
				<div v-for="disease in profile.diseases" :key="disease.id" class="item disease">
					<div class="disease">
						<button-icon-open @click.native="toggleOpen" icon="arrow"><b>{{ $t('categories.diseases.'+disease.name.replace(/ /g, '_').replace(/'/g, '´').toLowerCase()) }}</b></button-icon-open>
						<div class="btn-group">
							<button-icon-loading @click.native="editDisease(disease.id)" icon="edit" class="btn-edit"/>
							<button-icon-loading @click.native="deleteDisease(disease.id)" :loading="loading.delete.disease.has(disease.id)" icon="trash" class="btn-delete"/>
						</div>
					</div>
					<div class="comments openable"><span>{{ disease.comments }}</span></div>
				</div>
			</div>
			<h2>
				<span>{{ $t('labels.profile.family_information') }}</span>
				<button-icon-text-loading @click.native="addRelation()" icon="plus-w" class="plus">{{ $t('buttons.actions.add_relation') }}</button-icon-text-loading>
			</h2>
			<div>
				<div v-for="relation in profile.relations" :key="relation.id" class="item relation">
					<div class="relation">
						<button-icon-open @click.native="toggleOpen" icon="arrow">
							<b>{{ $t('categories.relations.'+relation.relation.replace(/ /g, '_').replace(/'/g, '´').toLowerCase()) }}</b>
							<span>{{ relation.name }}</span>
						</button-icon-open>
						<div class="btn-group">
							<button-icon-text-loading @click.native="addRelationContact(relation.id)" icon="plus-w" class="plus">{{ $t('buttons.actions.add_contact') }}</button-icon-text-loading>
							<button-icon-loading @click.native="editRelation(relation.id)" icon="edit" class="btn-edit"/>
							<button-icon-loading @click.native="deleteRelation(relation.id)" :loading="loading.delete.relation.has(relation.id)" icon="trash" class="btn-delete"/>
						</div>
					</div>
					<div class="contacts openable">
						<div v-for="contact in relation.contacts" :key="contact.id" class="item sub-item relation contact">
							<div class="data">
								<b>{{ $t('labels.general.'+contact.type.replace(/ /g, '_').replace(/'/g, '´').toLowerCase()) }}</b>
								<span>{{ contact.contact }}</span>
							</div>
							<div class="btn-group">
								<button-icon-loading @click.native="editRelationContact(relation.id, contact.id)" icon="edit" class="btn-edit"/>
								<button-icon-loading @click.native="deleteRelationContact(relation.id, contact.id)" :loading="loading.delete.contact.has(contact.id)" icon="trash" class="btn-delete"/>
							</div>
						</div>
					</div>
				</div>
			</div>
			<h2>{{ $t('labels.profile.other_information') }}</h2>
			<h3>
				<span>{{ $t('labels.profile.social_numbers') }}</span>
				<button-icon-text-loading @click.native="addSSNumber()" icon="plus-w" class="plus">{{ $t('buttons.actions.add_number') }}</button-icon-text-loading>
			</h3>
			<div>
				<div v-for="ssnumber in profile.ssnumbers" :key="ssnumber.id" class="item ssnumber">
					<div class="data">
						<b>{{ $t('labels.numbers.'+ssnumber.type.replace(/ /g, '_').replace(/'/g, '´').toLowerCase()) }}</b>
						<span>{{ ssnumber.number }}</span>
					</div>
					<div class="btn-group">
						<button-icon-loading @click.native="editSSNumber(ssnumber.id)" icon="edit" class="btn-edit"/>
						<button-icon-loading @click.native="deleteSSNumber(ssnumber.id)" :loading="loading.delete.ssnumber.has(ssnumber.id)" icon="trash" class="btn-delete"/>
					</div>
				</div>
			</div>
			<h3>
				<span>{{ $t('labels.profile.insurances') }}</span>
				<button-icon-text-loading @click.native="addInsurance()" icon="plus-w" class="plus">{{ $t('buttons.actions.add_insurance') }}</button-icon-text-loading>
			</h3>
			<div>
				<div v-for="insurance in profile.insurances" :key="insurance.id" class="item insurance">
					<div class="data">
						<b>{{ insurance.name }}</b>
						<span>{{ insurance.number }}</span>
					</div>
					<div class="btn-group">
						<button-icon-loading @click.native="editInsurance(insurance.id)" icon="edit" class="btn-edit"/>
						<button-icon-loading @click.native="deleteInsurance(insurance.id)" :loading="loading.delete.insurance.has(insurance.id)" icon="trash" class="btn-delete"/>
					</div>
				</div>
			</div>
		</div>
		<watch-profile-edit v-if="modalProfileForm.open" :params="modalProfileForm.params" :user_uid="user_uid" :watch_id="watch_id" :data="watch" @close="closeModal('modalProfileForm', arguments)"/>
		<contact-form v-if="modalContactForm.open" :params="modalContactForm.params" :user_uid="user_uid" :watch_id="watch_id" @close="closeModal('modalContactForm', arguments)"/>
		<disease-form v-if="modalDiseaseForm.open" :params="modalDiseaseForm.params" :user_uid="user_uid" :watch_id="watch_id" @close="closeModal('modalDiseaseForm', arguments)"/>
		<relation-form v-if="modalRelationForm.open" :params="modalRelationForm.params" :user_uid="user_uid" :watch_id="watch_id" @close="closeModal('modalRelationForm', arguments)"/>
		<relation-contact-form v-if="modalRelationContactForm.open" :params="modalRelationContactForm.params" :user_uid="user_uid" :watch_id="watch_id" @close="closeModal('modalRelationContactForm', arguments)"/>
		<ss-number-form v-if="modalSSNumberForm.open" :params="modalSSNumberForm.params" :user_uid="user_uid" :watch_id="watch_id" @close="closeModal('modalSSNumberForm', arguments)"/>
		<insurance-form v-if="modalInsuranceForm.open" :params="modalInsuranceForm.params" :user_uid="user_uid" :watch_id="watch_id" @close="closeModal('modalInsuranceForm', arguments)"/>
	</layout-main-component>
</template>

<script>
import WatchProfileEdit from './WatchProfileEdit'
import ContactForm from './ContactForm'
import DiseaseForm from './DiseaseForm'
import RelationForm from './RelationForm'
import RelationContactForm from './RelationContactForm'
import SsNumberForm from './SSNumberForm'
import InsuranceForm from './InsuranceForm'
export default {
	components: {
		WatchProfileEdit,
		ContactForm,
		DiseaseForm,
		RelationForm,
		RelationContactForm,
		SsNumberForm,
		InsuranceForm
	},
	props: [
		'user_uid',
		'watch_id',
		'watch'
	],
	data () {
		return {
			profile: null,
			loading: {
				profile: false,
				delete: {
					contact: new Set(),
					disease: new Set(),
					relation: new Set(),
					ssnumber: new Set(),
					insurance: new Set()
				}
			},
			modalProfileForm: {
				open: false,
				params: {}
			},
			modalContactForm: {
				open: false,
				params: {}
			},
			modalDiseaseForm: {
				open: false,
				params: {}
			},
			modalRelationForm: {
				open: false,
				params: {}
			},
			modalRelationContactForm: {
				open: false,
				params: {}
			},
			modalSSNumberForm: {
				open: false,
				params: {}
			},
			modalInsuranceForm: {
				open: false,
				params: {}
			}
		}
	},
	computed: {
		age () {
			return this.$moment().diff(this.profile.birthday, 'years', false)
		},
		height () {
			const height = Number(this.profile.height)
			return height ? (height / 100).toLocaleString() + ' m' : ''
		},
		weight () {
			const weight = Number(this.profile.weight)
			return weight ? (weight / 1000).toLocaleString() + ' kg' : ''
		}
	},
	methods: {
		emitWatchProfileUpdated() {
			this.$root.$emit('watch-profile-updated', this.profile)
		},
		getProfile (emit = false) {
			this.loading.profile = true
			this.$api.profile.get(this, this.user_uid, this.watch_id).then(response => {
				this.$log.info('watch profile', 'profile.get OK', response)()
				this.profile = response.body
				if (emit) {
					this.emitWatchProfileUpdated()
				}
			}).catch(errors => {
				this.$log.error('watch profile', 'profile.get ERROR', errors)()
			}).finally(() => {
				this.loading.profile = false
			})
		},
		editProfile () {
			this.openModal('modalProfileForm', { action: 'edit' })
		},
		addContact () {
			this.openModal('modalContactForm', { action: 'add' })
		},
		editContact (id) {
			this.openModal('modalContactForm', { action: 'edit', id })
		},
		deleteContact (id) {
			if (confirm('Delete?')) {
				this.loading.delete.contact.add(id)
				this.$forceUpdate()
				this.$api.profile.contacts.delete(this, this.user_uid, this.watch_id, id).then(response => {
					this.$log.info('watch profile', 'profile.contacts.delete OK', response)()
					this.getProfile(true) // true => emit event
				}).catch(errors => {
					this.$log.error('watch profile', 'profile.contacts.delete ERROR', errors)()
				}).finally(() => {
					this.loading.delete.contact.delete(id)
				})
			}
		},
		addDisease () {
			this.openModal('modalDiseaseForm', { action: 'add' })
		},
		editDisease (id) {
			this.openModal('modalDiseaseForm', { action: 'edit', id })
		},
		deleteDisease (id) {
			if (confirm('Delete?')) {
				this.loading.delete.disease.add(id)
				this.$forceUpdate()
				this.$api.profile.diseases.delete(this, this.user_uid, this.watch_id, id).then(response => {
					this.$log.info('watch profile', 'profile.diseases.delete OK', response)()
					this.getProfile(true) // true => emit event
				}).catch(errors => {
					this.$log.error('watch profile', 'profile.diseases.delete ERROR', errors)()
				}).finally(() => {
					this.loading.delete.disease.delete(id)
				})
			}
		},
		addRelation () {
			this.openModal('modalRelationForm', { action: 'add' })
		},
		editRelation (id) {
			this.openModal('modalRelationForm', { action: 'edit', id })
		},
		deleteRelation (id) {
			if (confirm('Delete?')) {
				this.loading.delete.relation.add(id)
				this.$forceUpdate()
				this.$api.profile.relations.delete(this, this.user_uid, this.watch_id, id).then(response => {
					this.$log.info('watch profile', 'profile.relations.delete OK', response)()
					this.getProfile(true) // true => emit event
				}).catch(errors => {
					this.$log.error('watch profile', 'profile.relations.delete ERROR', errors)()
				}).finally(() => {
					this.loading.delete.relation.delete(id)
				})
			}
		},
		addRelationContact (relation_id) {
			this.openModal('modalRelationContactForm', { action: 'add', relation_id })
		},
		editRelationContact (relation_id, contact_id) {
			this.openModal('modalRelationContactForm', { action: 'edit', id: contact_id, relation_id })
		},
		deleteRelationContact (relation_id, contact_id) {
			if (confirm('Delete?')) {
				this.loading.delete.contact.add(contact_id)
				this.$forceUpdate()
				this.$api.profile.relations.contacts.delete(this, this.user_uid, this.watch_id, relation_id, contact_id).then(response => {
					this.$log.info('watch profile', 'profile.relations.contacts.delete OK', response)()
					this.getProfile(true) // true => emit event
				}).catch(errors => {
					this.$log.error('watch profile', 'profile.relations.contacts.delete ERROR', errors)()
				}).finally(() => {
					this.loading.delete.contact.delete(contact_id)
				})
			}
		},
		addSSNumber () {
			this.openModal('modalSSNumberForm', { action: 'add' })
		},
		editSSNumber (id) {
			this.openModal('modalSSNumberForm', { action: 'edit', id })
		},
		deleteSSNumber (id) {
			if (confirm('Delete?')) {
				this.loading.delete.ssnumber.add(id)
				this.$forceUpdate()
				this.$api.profile.ssnumbers.delete(this, this.user_uid, this.watch_id, id).then(response => {
					this.$log.info('watch profile', 'profile.ssnumbers.delete OK', response)()
					this.getProfile(true) // true => emit event
				}).catch(errors => {
					this.$log.error('watch profile', 'profile.ssnumbers.delete ERROR', errors)()
				}).finally(() => {
					this.loading.delete.ssnumber.delete(id)
				})
			}
		},
		addInsurance () {
			this.openModal('modalInsuranceForm', { action: 'add' })
		},
		editInsurance (id) {
			this.openModal('modalInsuranceForm', { action: 'edit', id })
		},
		deleteInsurance (id) {
			if (confirm('Delete?')) {
				this.loading.delete.insurance.add(id)
				this.$forceUpdate()
				this.$api.profile.insurances.delete(this, this.user_uid, this.watch_id, id).then(response => {
					this.$log.info('watch profile', 'profile.insurances.delete OK', response)()
					this.getProfile(true) // true => emit event
				}).catch(errors => {
					this.$log.error('watch profile', 'profile.insurances.delete ERROR', errors)()
				}).finally(() => {
					this.loading.delete.insurance.delete(id)
				})
			}
		},
		toggleOpen (event) {
			const button = event.currentTarget
			const openable = event.currentTarget.parentElement.parentElement.querySelector('.openable')

			if (button) {
				button.classList.toggle('open')
			}

			if (openable) {
				let height = 0
				for (let i = 0; i < openable.children.length; i++) {
					let style = getComputedStyle(openable.children[i])
					height += openable.children[i].offsetHeight
				}

				if (openable.classList.contains('open')) {
					openable.style.height = 0
				} else {
					openable.style.height = `${height}px`
				}

				openable.classList.toggle('open')
			}
		},
		openModal (modal, params = {}) {
			this[modal].open = true
			this[modal].params = params
		},
		closeModal (modal, args) {
			this[modal].open = false
			this[modal].params = {}
			if (args[0].reload) {
				this.getProfile(true) // true => emit event
			}
		}
	},
	beforeCreate () {
		this.$title('Watch Profile')
	},
	created () {
		this.getProfile()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/profile/WatchProfile.vue